<template>
    <div class="count-down-timer"  :class="{'bgr-iamge': isShowBgrImage}">
        <div v-if="isTitle" class="count-down-timer__title">
            {{ title }}
        </div>
        <div v-if="nextDrawDate" class="count-down-timer__title-next-date">
            {{ getTranslatedText('next draw') }}
            <span>{{ nextDrawDate }}</span>
        </div>
        <div v-if="isTitleIcon" class="count-down-timer__title-icon">
            <div class="count-down-timer__box-icon" @click="onClickMoveToYT">
                <img
                    v-if="titleIcon"
                    :src="require(`@/assets/images/common/${titleIcon}`)"
                    :alt="titleIcon"
                />
                <span>{{ title }} </span>
            </div>
        </div>
        <div class="count-down-timer__container-time">
            <div class="count-down-timer__item-time" v-if="days > 0">
                <img v-if="isShowBgrImage" class="count-down-timer__item-time__image" src="@/assets/images/common/clock.png"/>
                <label class="count-down-timer__item-time__number">
                    <span>{{ TwoDigits(days) }} </span>
                </label>
                <label class="text" v-if="days > 1">{{
                    getTranslatedText("days")
                }}</label>
                <label class="text" v-else>{{
                    getTranslatedText("day")
                }}</label>
            </div>
            <div class="count-down-timer__item-time">
                <img v-if="isShowBgrImage" class="count-down-timer__item-time__image" src="@/assets/images/common/clock.png"/>
                <label class="count-down-timer__item-time__number">
                    <span>{{ TwoDigits(hours) }}</span>
                </label>
                <label class="text" v-if="hours > 1">{{
                    getTranslatedText("hrs")
                }}</label>
                <label class="text" v-else>{{
                    getTranslatedText("hour")
                }}</label>
            </div>
            <div class="count-down-timer__item-time">
                <img v-if="isShowBgrImage" class="count-down-timer__item-time__image" src="@/assets/images/common/clock.png"/>
                <label class="count-down-timer__item-time__number">
                    <span>{{ TwoDigits(minutes) }}</span>
                </label>
                <label class="text">{{ getTranslatedText("mins") }}</label>
            </div>
            <div class="count-down-timer__item-time">
                <img v-if="isShowBgrImage" class="count-down-timer__item-time__image" src="@/assets/images/common/clock.png"/>
                <label class="count-down-timer__item-time__number">
                    <span>{{ TwoDigits(seconds) }}</span>
                </label>
                <label class="text">{{ getTranslatedText("secs") }}</label>
            </div>
        </div>
    </div>
</template>

<script>
import languageMixin from "@/mixins/language/language-mixin";
import { renderLocaleNumber } from "../utils";
export default {
    mixins: [languageMixin],
    props: {
        date: {
            type: String,
        },
        isTitle: {
            type: Boolean,
            default: false,
        },
        isTitleIcon: {
            type: Boolean,
            default: false,
        },
        isShowBgrImage: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        titleIcon: {
            type: String,
            default: "",
        },
        titleIconText: {
            type: String,
            default: "",
        },
        nextDrawDate: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            now: Math.trunc(new Date().getTime() / 1000),
            timer: null,
        };
    },
    mounted() {
        window.setInterval(() => {
            this.now = Math.trunc(new Date().getTime() / 1000);
        }, 1000);
    },
    computed: {
        dateInMilliseconds() {
            const date = this.getDate(this.date);
            const milliSecond = Math.trunc(Date.parse(date) / 1000);
            return milliSecond > 0 ? milliSecond : "00";
        },
        seconds() {
            const seconds = (this.dateInMilliseconds - this.now) % 60;
            return seconds > 0 ? seconds : "00";
        },
        minutes() {
            const minutes =
                Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
            return minutes > 0 ? minutes : "00";
        },
        hours() {
            const hours =
                Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
            return hours > 0 ? hours : "00";
        },
        days() {
            const days = Math.trunc(
                (this.dateInMilliseconds - this.now) / 60 / 60 / 24
            );
            return days > 0 ? days : "00";
        },
    },
    methods: {
        TwoDigits(value) {
            if (value < 0) {
                return `00`;
            }
            if (value.toString().length <= 1) {
                return `0${value}`;
            }

            value = parseInt(value);
            return value;
        },
        convertDateForIos(v) {
            let result = null;
            try {
                const arr = v.toString().split(/[- :]/);
                result = new Date(
                    Date.UTC(arr[2], arr[1] - 1, arr[0], arr[3], arr[4], arr[5])
                );
            } catch (e) {
                result = new Date(v);
            }
            return result;
        },
        getDate(v) {
            return this.convertDateForIos(v);
        },

        onClickMoveToYT() {
            window.open('https://www.youtube.com/channel/UCCZxGo-Fgh-Vd47jxUBjnww', "_blank")
        }
    },
};
</script>
<style
    scoped
    lang="scss"
    src="@/assets/scss/common/count-down-timer/count-down-timer.scss"
/>
